import React, { useEffect, useState } from 'react';

import { db } from '../../services/ApiManagement/Index';

import BackHeader from '../../components/BackHeader';
import Offline from '../../components/OfflineMessage';

import { Label } from '../../components/Generic';
import { Container, Content } from './styles';

const Sync: React.FC = () => {
  const [queue, setQueue] = useState<any>([]);

  useEffect(() => {
    getQueue();
  }, []);

  const getQueue = async () => {
    try {
      const response = await db.toPerform.toArray();

      setQueue(response);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Container>
      <BackHeader title="Sincronização" />

      <Content>
        <Label>Fila de ações</Label>

        {queue?.map((item: any) => (
          <div>
            <strong>{item.method}</strong>
            <p>{item.url}</p>
          </div>
        ))}
      </Content>
    </Container>
  );
};

export default Sync;
